import { render, staticRenderFns } from "./SavedSearchesList.vue?vue&type=template&id=cbc77e8c&scoped=true"
import script from "./SavedSearchesList.vue?vue&type=script&lang=js"
export * from "./SavedSearchesList.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchesList.vue?vue&type=style&index=0&id=cbc77e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc77e8c",
  null
  
)

export default component.exports